import { render, staticRenderFns } from "./QueueBase.vue?vue&type=template&id=9b8655ba&"
import script from "./QueueBase.vue?vue&type=script&lang=js&"
export * from "./QueueBase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports